
import { useState } from "react";
import { useProfiles } from "@/hooks/useProfiles";
import { ProfileTemplateSelection, ProfileTemplate } from "@/components/profiles/ProfileTemplateSelection";
import { NewProfileWizard } from "@/components/profiles/NewProfileWizard";

export default function NewProfilePage() {
  const { addProfile } = useProfiles();
  const [selectedTemplate, setSelectedTemplate] = useState<ProfileTemplate | null>(null);

  const handleTemplateSelect = (template: ProfileTemplate) => {
    setSelectedTemplate(template);
  };

  if (!selectedTemplate) {
    return <ProfileTemplateSelection onTemplateSelect={handleTemplateSelect} />;
  }

  return (
    <NewProfileWizard 
      template={selectedTemplate}
      onSave={(profileData, isDraft) => {
        return addProfile(profileData, isDraft);
      }}
    />
  );
}
